import {createHashHistory} from 'history';

const browserHistory = createHashHistory();

export default browserHistory;
